import { SourceTypes } from '../../../constants';
import type { SourceValue } from '../sources';

export function sourceValidation(sourceValue: SourceValue): boolean {
  const { platform, connectionType, source, authentication } = sourceValue;

  switch (platform) {
    case SourceTypes.FACEBOOK:
      return source?.status === 'connected';

    case SourceTypes.VKONTAKTE:
      if (connectionType === 'vkontakteOwnProfile') {
        return !!authentication?.identity;
      }

      return !!source;

    case SourceTypes.YOUTUBE:
      return !!sourceValue.youtubeChannel;

    case SourceTypes.INSTAGRAM:
      if (
        connectionType === 'legacyInstagramBusinessAccount' ||
        connectionType === 'legacyInstagramPersonalAccount'
      ) {
        return !!authentication;
      }

      return !!source;

    case SourceTypes.LINKEDIN:
    case SourceTypes.PINTEREST:
    case SourceTypes.RSS:
    case SourceTypes.TIKTOK:
    case SourceTypes.TUMBLR:
    case SourceTypes.TWITTER:
    case SourceTypes.VIMEO:
      return !!sourceValue.source;

    default:
      return false;
  }
}
